import { render } from "./Attivita.vue?vue&type=template&id=6f8f01dd&scoped=true"
import script from "./Attivita.vue?vue&type=script&lang=js"
export * from "./Attivita.vue?vue&type=script&lang=js"

import "./Attivita.vue?vue&type=style&index=0&id=6f8f01dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8f01dd"]])

export default __exports__